'use strict';

// Provider logo assets, hosted on the EatLove static CDN.
// TODO: google_health URL is a temporary production asset; replace with the official asset when delivered.
const PROVIDER_LOGO_IMAGES = {
    fitbit: 'https://static.chewba.info/images/fitbit-app-icon.svg',
    google_health: 'https://static.chewba.info/images/c8c5c96f-02ea-4370-a387-a0df46454653.png',
};

export const getProviderLogo = (provider) => PROVIDER_LOGO_IMAGES[provider] || null;
